import { createApp } from 'vue';
import VueDatePicker from '@vuepic/vue-datepicker';
import { isLength, isInt, isEmpty } from 'validator';
import { translations } from '@tools/translations/translations';
import { TwigFormValidator } from '@tools/twig-form/validator';
import { showSubmitLoader } from '@atoms/spinner';
import {
  getYesterdayDate,
  parseStringToDate,
  parseDateToString,
} from '@tools/date';

/**
 * Component used to validate update contact form
 */
export const contact = () => {
  const buyerTeamSize = document.querySelector('#update_deal_buyerTeamSize')
    .value;
  const quantity = document.querySelector(
    '#create_deal_quantity, #update_deal_quantity',
  );
  const dateValue = document.querySelector('#update_deal_entryDate').value;
  const current = dateValue.length > 1 ? parseStringToDate(dateValue) : null;
  const unknownEntryDate = document.querySelector('#update_deal_unknownEntryDate').checked;

  const component = {
    delimiters: [ '${', '}' ],
    components: {
      VueDatePicker,
    },
    data() {
      return {
        toggleEntryDate: unknownEntryDate,
        toggleDuration: quantity && Number(quantity.value) === -1, // if infinite , disable input and check unlimited box
        date: {
          current,
          format: 'dd/MM/yyyy',
          disabledDates: getYesterdayDate(),
        },
        deal: {
          buyerTeamSize,
        },
      };
    },
    watch: {
      toggleEntryDate(val) {
        document.getElementById(
          'update_deal_entryDate',
        ).value = val ? null : this.date.current;
      },
    },
    mounted() {
      this.handleFormSubmit();

      const quantityInput = document.querySelector(
        '#create_deal_quantity, #update_deal_quantity',
      );
      if (quantityInput && Number(quantityInput.value) === -1) {
        quantityInput.value = '';
      }
      // If google tag manager is deactivated, dataLayer always exist
      // @see https://bureaux-a-partager.atlassian.net/browse/MATCH-8158
      if (window.dataLayer === undefined) {
        window.dataLayer = [];
      }
    },
    methods: {
      /**
       * datepickerValueChanged
       * @param date
       * @description Trigger when a date is picked. Set the input hidden with proper value.
       */
      datepickerValueChanged(date) {
        document.getElementById(
          'update_deal_entryDate',
        ).value = parseDateToString(date);
      },
      /**
       * Display the calendar above the input if there's not enough space to display whole calendar
       */
      datepickerOpened() {
        this.$nextTick(() => {
          const calendar = document.querySelector('.contact-completion .dp__outer_menu_wrap');
          const rect = calendar.getBoundingClientRect();
          if (rect.bottom > window.innerHeight) {
            // 8px for natural padding between elements
            const offset = document.querySelector('.contact-completion .dp__main input').offsetHeight + 8;
            calendar.style.bottom = `${offset}px`;
          }
        });
      },
      handleFormSubmit() {
        const ctaButton = document.querySelector('form[name="update_deal"] button[type="submit"]');
        const validator = new TwigFormValidator({
          formSelector: 'form[name="update_deal"]',
          rules: {
            'update_deal[buyerOrgaName]': (value) => isLength(value, { min: 1, max: 50 }),
            'update_deal[buyerTeamSize]': (value) => isInt(value, { min: 1 }),
            'update_deal[quantity]': (value) => isEmpty(value) || isInt(value, { min: 1 }),
          },
          messages: {
            'update_deal[quantity]': translations.validators['form.validation.number.min'].replace('%min%', 1),
          },
          onSuccess: () => {
            showSubmitLoader(ctaButton);
            window.dataLayer.push({
              event: 'formContactSubmission',
              formType: 'contact-offer',
              formPosition: 'content',
              pageUrl: window.location.href,
            });
            return true;
          },
        });
        validator.init();
      },
    },
  };

  return createApp(component).mount('.contact-completion');
};
